document.addEventListener('DOMContentLoaded', function () {
    const cardContainer = document.getElementById('card-container');
    let hasOpened = false;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !hasOpened) {
                if (entry.intersectionRatio >= 0.70) {
                    entry.target.classList.add('visible');
                    hasOpened = true;
                    observer.disconnect();
                }
            }
        });
    }, {
        threshold: [0.70]
    });

    observer.observe(cardContainer);
});
const selectElement = document.querySelector('.index-search-input');

selectElement.addEventListener('change', function () {
    const selectedValue = this.options[this.selectedIndex].text;

    if (selectedValue) {
        this.style.color = '#0047AB';
    } else {
        this.style.color = 'black';
    }
});

window.addEventListener('load', function () {
    const selectedValue = selectElement.options[selectElement.selectedIndex].text;
    if (selectedValue) {
        selectElement.style.color = '#0047AB';
    }
});




var swiper = new Swiper(".mySwiper", {
    spaceBetween: 30,
    centeredSlides: false,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
    },
    loop: true,
    speed: 1000,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});


$(document).ready(function () {
    // console.log('ready');
    const eventYear = $("#event-year");
    const eventName = $("#event-name");
    const bibNo = $("#bib-no");
    const bibDiv = $("#index-bib-home-div");
    const eventForm = $("#event-form");
    let EVENT_ID;
    let debounceTimeout;
    let debounceTimeout2;
    let cachedEventList = null;
    let lastSearchedEvent = "";
    let cachedParticipantList = null;
    let lastSearchedParticipant = "";
    let autocompleteInitialized = false;
    // console.log(eventYear, eventName, bibNo);

    const currentYear = new Date().getFullYear();
    const years = Array.from({
        length: currentYear - 2015
    }, (_, index) => currentYear - index);

    years.forEach((e) => {
        eventYear.append(`<option value="${e}" class="">${e}</option>`)
    });

    eventYear.on("change", (e) => {
        bibDiv.addClass("index-bib-home");
        cachedEventList = null
        lastSearchedEvent = ""
        eventName.focus();
    });

    function eventNameAutoComplete() {
        if (autocompleteInitialized && eventName.autocomplete("instance")) {
            eventName.autocomplete("destroy");
        }
        eventName.autocomplete({
            source: function (request, response) {
                eventName.css("color", "black");

                let inputValue = eventName.val().trim();
                if (cachedEventList && inputValue === lastSearchedEvent) {
                    response(cachedEventList);
                    return;
                }

                axios.get('frontend/api/event-search', {
                    params: {
                        year: eventYear.val(),
                        name: eventName.val()
                    }
                }).then(res => {
                    // var data = res.data;
                    let decodedData = atob(res.data.data);
                    let data = JSON.parse(decodedData);
                    cachedEventList = data.events.length === 0 ? [{ label: "No Events Found", value: null }] : data.events.map(event => ({
                        label: event.highlight ? event.highlight : event.name,
                        value: event.event_id,
                        plainText: event.name
                    }));
                    lastSearchedEvent = inputValue;
                    response(cachedEventList);
                    $(".ui-autocomplete").each(function () {
                        $(this).toggleClass("ac-scroll-enabled", cachedEventList.length > 5);
                    });
                }).catch(error => {
                    console.error("API call error:", error);
                    response([]);
                    Swal.fire({
                        icon: 'info',
                        title: 'Something Went Wrong',
                        text: '',
                    });
                });
            },
            minLength: 3,
            autoFocus: false,
            focus: function(event, ui) {
                eventName.val(ui.item.plainText); 
                return false; 
            },

            open: function () {
                var parentWidth = eventName.outerWidth();
                $("ul.ui-menu").width(parentWidth);
            },
            select: function (event, ui) {
                EVENT_ID = ui.item.value;
                eventName.val(ui.item.plainText);
                eventName.css("color", "rgb(0, 71, 171)");
                bibDiv.removeClass("index-bib-home");
                bibNo.focus();
                return false;
            }
        });
        eventName.autocomplete("instance")._renderItem = function (ul, item) {
            return $("<li>")
                .append($("<div>").html(item.label))
                .appendTo(ul);
        };

        autocompleteInitialized = true;

        eventName.autocomplete("search", eventName.val());
    }

    function setEventNameAutoComplete() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            if (eventName.val().length >= 3) {
                eventNameAutoComplete();
            }
        }, 0);
    }

    eventName.on("input", () => {
        EVENT_ID = null;
        setEventNameAutoComplete();
    });

    eventName.on("focus", () => {
        if (cachedEventList && cachedEventList.length > 0) {
            eventName.autocomplete("option", "source", function (request, response) {
                response(cachedEventList);
            });
            eventName.autocomplete("search", eventName.val());
            return;
        }
        setEventNameAutoComplete();
    });

    function setRunnerNameAutoComplete() {
        clearTimeout(debounceTimeout2);
        debounceTimeout2 = setTimeout(() => {
            let inputValue = bibNo.val().trim();

            if (EVENT_ID) {
                let condition = /^[A-Za-z\s]+$/.test(bibNo);
                if (condition) {
                    if (inputValue.length >= 3) {
                        runnerNameAutoComplete();
                    }
                } else {
                    if (inputValue.length >= 1) {
                        runnerNameAutoComplete();
                    }
                }
            } else {
                if (bibNo.data("ui-autocomplete")) {
                    bibNo.autocomplete("close");
                }
            }
        }, 0);
    }

    bibNo.on("input", () => {
        setRunnerNameAutoComplete();
    });

    bibNo.on("focus", () => {
        let inputValue = bibNo.val().trim();

        if (EVENT_ID) {
            let condition = /^[A-Za-z\s]+$/.test(bibNo);
            if (condition) {
                if (inputValue.length >= 3) {
                    if (cachedParticipantList && cachedParticipantList.length > 0) {
                        bibNo.autocomplete({
                            source: function (request, response) {
                                response(cachedParticipantList);
                            }
                        });
                        bibNo.autocomplete("search", inputValue);
                    }
                }
            } else {
                if (inputValue.length >= 1) {
                    if (cachedParticipantList && cachedParticipantList.length > 0) {
                        bibNo.autocomplete({
                            source: function (request, response) {
                                response(cachedParticipantList);
                            }
                        });
                        bibNo.autocomplete("search", inputValue);
                    }
                }
            }
        } else {
            if (bibNo.data("ui-autocomplete")) {
                bibNo.autocomplete("close");
            }
        }
    });

    function runnerNameAutoComplete() {
        if (autocompleteInitialized && bibNo.autocomplete("instance")) {
            bibNo.autocomplete("destroy");
        }
        bibNo.autocomplete({
            source: function (request, response) {

                let inputValue = bibNo.val().trim();
                let condition = /^[A-Za-z\s]+$/.test(inputValue);
                if (condition) {
                    if (inputValue.length < 3) {
                        response([]);
                        return;
                    }
                } else {
                    if (inputValue.length < 1) {
                        response([]);
                        return;
                    }
                }

                if (cachedParticipantList && inputValue === lastSearchedParticipant) {
                    response(cachedParticipantList);
                    return;
                }

                axios.get('frontend/api/event-bibs', {
                    params: {
                        term: bibNo.val(),
                        event_id: EVENT_ID,
                    }
                }).then(res => {
                    // var data = res.data;
                    let decodedData = atob(res.data.data);
                    let data = JSON.parse(decodedData);
                    cachedParticipantList = data.participants.length === 0 ? [{ label: "No Runners Found", value: null }] : data.participants.map((participant) => ({
                        label: participant.highlight ? `${participant.highlight}  (${participant.bibno})` : `${participant.full_name}  (${participant.bibno})`,
                        value: participant.bibno,
                    }));
                    lastSearchedParticipant = inputValue;
                    response(cachedParticipantList);
                    $(".ui-autocomplete").each(function () {
                        $(this).toggleClass("ac-scroll-enabled", cachedParticipantList.length > 5);
                    });
                }).catch(error => {
                    console.error("API call error:", error);
                    response([]);
                    Swal.fire({
                        icon: 'info',
                        title: 'Something Went Wrong',
                        text: '',
                    });
                });
            },
            minLength: 1,
            autoFocus: false,
            open: function () {
                var parentWidth = bibNo.outerWidth();
                $("ul.ui-menu").width(parentWidth);
                $("ul.ui-menu").css("z-index", "999");
            },
            select: function (event, ui) {
                if (!ui.item.value || ui.item.value == "No Runners Found") {
                    return false;
                }
                bibNo.val(ui.item.value);
                eventForm.submit();
            }
        });
        bibNo.autocomplete("instance")._renderItem = function (ul, item) {
            return $("<li>")
                .append($("<div>").html(item.label))
                .appendTo(ul);
        };

        autocompleteInitialized = true;

        bibNo.autocomplete("search", bibNo.val());
    }

    eventForm.on("submit", (e) => {
        e.preventDefault();
        var bib_no = bibNo.val();
        if (!EVENT_ID || EVENT_ID == "No Events Found") {
            Swal.fire({
                icon: 'info',
                title: 'Please Select Event Name',
                text: '',
            });
            setEventNameAutoComplete();
            return false;
        }
        if (!bib_no) {
            let str = JSON.stringify({
                e_name: eventName.val(),
                e_id: EVENT_ID
            });
            let slug = btoa(str);
            const resultUrl = new URL(window.location.origin + '/results');
            resultUrl.searchParams.set('q', slug);
            window.location = resultUrl.toString();
            return;
            // Swal.fire({
            //     icon: 'info',
            //     title: 'Please Enter BIB No/Name.',
            //     text: '',
            // });
            // return false;
        }

        if (isNaN(bib_no)) {
            return false;
        }

        axios.get('frontend/api/event-runner-exists', {
            params: {
                event_id: EVENT_ID,
                bibNo: bib_no
            }
        }).then(response => {
            let decodedData = atob(response.data.data);
            let data = JSON.parse(decodedData);
            if (data.status) {
                const resultUrl = new URL(window.location.origin + '/results');
                // resultUrl.searchParams.set('e_id', EVENT_ID);
                // resultUrl.searchParams.set('e_name', eventName.val());
                // resultUrl.searchParams.set('bibNo', bibNo.val());

                const slug = btoa(JSON.stringify({
                    e_name: eventName.val(),
                    e_id: EVENT_ID,
                    bibNo: bibNo.val()
                }));
                resultUrl.searchParams.set('q', slug);
                window.location.href = resultUrl.toString();
            } else {
                // alert('Runner Not Found');
                Swal.fire({
                    icon: 'info',
                    title: 'Something went wrong.',
                    html: `Please check your BIB number and try again.<br>
                        If you still can’t find your results, please raise a ticket on the 
                        <a href="/contact-us" target="_blank" class="text-primary fw-bold">Contact Us</a> page.`,
                });
            }
        }).catch(error => {
            console.error("API call error:", error);
            // alert('Something Went Wrong');
            Swal.fire({
                icon: 'info',
                title: 'Something Went Wrong',
                text: '',
            });
        });
    });

});

// home and live server search submit btn ui update
document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('.index-eventname-input-live, .index-bib-input');
    const searchBtn = document.querySelector('.event-input-searchbtn-live');

    inputs.forEach(input => {
        input.addEventListener('input', function () {
            if (this.value.trim() !== '') {
                searchBtn.classList.add('active');
            } else {
                let anyInputHasValue = false;
                inputs.forEach(inp => {
                    if (inp.value.trim() !== '') {
                        anyInputHasValue = true;
                    }
                });
                if (!anyInputHasValue) {
                    searchBtn.classList.remove('active');
                }
            }
        });

        input.addEventListener('focus', function () {
            searchBtn.classList.add('active');
        });

        input.addEventListener('blur', function () {
            let anyInputHasValue = false;
            inputs.forEach(inp => {
                if (inp.value.trim() !== '') {
                    anyInputHasValue = true;
                }
            });
            if (!anyInputHasValue) {
                searchBtn.classList.remove('active');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.testimonials-slider', {
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});